import { Camera, ImagePlus } from "lucide-react";

export default function CanvasEditor({
  canvasRef,
  fileName,
  handleUpload,
  inputRef,
  mobileMode,
  onOpenEditor,
  handleMouseDown,
  handleMouseUp,
  handleMouseMove,
  handleTouchStart,
  handleTouchMove,
  handleTouchEnd,
}) {
  return (
    <div className="canvas-container">
      <div className="collage-canvas-stage">
        <canvas
          ref={canvasRef}
          role="img"
          aria-label="Editor de collage magnetico personalizado"
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseUp}
        onTouchStart={mobileMode ? undefined : handleTouchStart}
        onTouchMove={mobileMode ? undefined : handleTouchMove}
        onTouchEnd={mobileMode ? undefined : handleTouchEnd}
        onClick={mobileMode && fileName ? onOpenEditor : undefined}
        className={mobileMode ? "collage-canvas-mobile" : ""}
        style={{ touchAction: mobileMode ? "auto" : "none" }}
        />

        <label
          className={
            fileName
              ? "collage-canvas-upload has-image"
              : "collage-canvas-upload"
          }
        >
          <input
            ref={inputRef}
            type="file"
            accept="image/*"
            onChange={handleUpload}
          />

          {fileName ? (
            <Camera aria-hidden="true" />
          ) : (
            <span>
              <ImagePlus aria-hidden="true" />
              <strong>Clic aqui</strong>
              <small>Subir foto</small>
            </span>
          )}
        </label>
      </div>
    </div>
  );
}
